import React from 'react';
import WaterDashboard from '../components/dashboard/WaterDashboard';
import DefaultMeterDashboard from '../dashboards/DefaultMeterDashboard';

/** The company whose meters are a water plant. */
const WATER_COMPANY_ID = 362;

/**
 * Whether a company's meters are the water ones.
 *
 * The comparison tab compares water quantities — withdrawal, consumption,
 * tanker, treated — so it only means anything for the company those charts
 * were built for. That is the same decision this router already makes about
 * which dashboard to draw, so it is answered here rather than restated at the
 * page that shows the tabs.
 *
 * @param {number} companyId - The signed-in user's company.
 * @returns {boolean} True when the water dashboard and its comparison apply.
 */
export const hasWaterDashboard = (companyId) => companyId === WATER_COMPANY_ID;

/**
 * Main dashboard router component that renders the appropriate dashboard
 * based on the company ID
 */
const MeterDashboardRouter = ({ 
  companyId,
  meters,
  financialYearOptions,
  sourceOptions, 
  isLoading, 
  onRefresh 
}) => {
  // Route to specific dashboard based on companyId
  if (hasWaterDashboard(companyId)) {
    return (
      <WaterDashboard
        meters={meters}
        financialYearOptions={financialYearOptions}
        sourceOptions={sourceOptions}
        onRefresh={onRefresh}
      />
    );
  }

  // Default dashboard for all other companies
  return (
    <DefaultMeterDashboard
      financialYearOptions={financialYearOptions}
      sourceOptions={sourceOptions}
      onRefresh={onRefresh}
    />
  );
};

export default MeterDashboardRouter;